import { Plus, Briefcase } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AddDealDialog } from "./add-deal";
import { useState } from "react";

export const DealsEmptyOnboarding = () => {
  const [addDealOpen, setAddDealOpen] = useState(false);

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] bg-white rounded-lg shadow p-8 text-center">
      <div className="mb-6">
        <div className="mx-auto w-24 h-24 bg-primary/10 rounded-full flex items-center justify-center mb-4">
          <Briefcase className="w-12 h-12 text-primary" />
        </div>
        <h2 className="text-2xl font-semibold text-gray-900 mb-2">
          Start Your Deal Pipeline
        </h2>
        <p className="text-gray-600 max-w-md mx-auto">
          Start building your deal pipeline by adding your first company. Track
          applications, manage due diligence, and streamline your investment
          process.
        </p>
      </div>

      <div className="space-y-3">
        <Button
          onClick={() => setAddDealOpen(true)}
          size="lg"
          className="gap-2"
        >
          <Plus className="w-5 h-5" />
          Add Your First Deal
        </Button>

        <p className="text-sm text-gray-500">
          You can also import deals in bulk or connect integrations
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4 max-w-2xl">
        <div className="text-left p-4 border rounded-lg">
          <h3 className="font-medium text-gray-900 mb-1">Track Applications</h3>
          <p className="text-sm text-gray-600">
            Monitor deal flow and application status in one place
          </p>
        </div>
        <div className="text-left p-4 border rounded-lg">
          <h3 className="font-medium text-gray-900 mb-1">Manage Pipeline</h3>
          <p className="text-sm text-gray-600">
            Organize deals through customizable workflow stages
          </p>
        </div>
        <div className="text-left p-4 border rounded-lg">
          <h3 className="font-medium text-gray-900 mb-1">Generate Reports</h3>
          <p className="text-sm text-gray-600">
            Create AI-powered analysis and due diligence reports
          </p>
        </div>
      </div>

      <AddDealDialog open={addDealOpen} onOpenChange={setAddDealOpen} />
    </div>
  );
};
